import { DEFAULT_PAYMENT_METHOD_ID, STRIPE_PAYMENT_METHODS } from './PaymentMethodSelector.constants';

export const SET_ACTIVE_PAYMENT_METHOD = 'classpass/paymentMethods/SET_ACTIVE_PAYMENT_METHOD';

export const setActivePaymentMethod = paymentMethodId => ({ type: SET_ACTIVE_PAYMENT_METHOD, value: paymentMethodId });

const selectPaymentMethods = state => state.features.paymentMethods;
export const selectActivePaymentMethod = state => selectPaymentMethods(state).activePaymentMethodId;
export const selectIsPaymentMethodSepaCompatible = state => {
  return [STRIPE_PAYMENT_METHODS.IDEAL, STRIPE_PAYMENT_METHODS.SEPA, STRIPE_PAYMENT_METHODS.SOFORT].includes(
    selectActivePaymentMethod(state)
  );
};

const initialState = {
  activePaymentMethodId: DEFAULT_PAYMENT_METHOD_ID,
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_ACTIVE_PAYMENT_METHOD:
      return {
        ...state,
        activePaymentMethodId: action.value,
      };
    default:
      return state;
  }
}
